<template>
  <div class="queue-page">
    <top-bar :topbarList="queueTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { queueIndexMixins } from "@/mixins/queueIndexMixins";

export default {
  mixins: [queueIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped></style>
